import { AutocompleteOption } from '@types'

export const createAutocompleteOptions = <T>(
  array: T[],
  keys: { id: keyof T; label: keyof T } & Record<string, keyof T>
): AutocompleteOption[] => {
  return array.map(item => {
    const option: Record<string, any> = {
      id: item[keys.id],
      label: item[keys.label],
    }

    for (const [optionKey, itemKey] of Object.entries(keys)) {
      if (optionKey !== 'id' && optionKey !== 'label') {
        option[optionKey] = item[itemKey]
      }
    }

    return option as AutocompleteOption
  })
}
